import Repository from "../../repository";

export default {
    Get: (payload) => Repository.post(`/api/DriverSalarys/Get`, payload),
    GetActive: (payload) => Repository.post(`/api/DriverSalarys/GetActive`, payload),
    GetById: (payload) => Repository.post(`/api/DriverSalarys/GetById`, payload),
    Add: (payload) => Repository.post(`/api/DriverSalarys/Add`, payload),
    Copy: (payload) => Repository.post(`/api/DriverSalarys/Copy`, payload),
    Edit: (payload) => Repository.post(`/api/DriverSalarys/Edit`, payload),
    Delete: (payload) => Repository.post(`/api/DriverSalarys/Delete`, payload),
    ChangeStatus: (payload) => Repository.post(`/api/DriverSalarys/ChangeStatus`, payload),
}